import Draggable from "react-draggable";
import "./cephalo.css";
import { useEffect, useState } from "react";
import {
  Button,
  ConfigProvider,
  Descriptions,
  message,
  notification,
  Spin,
} from "antd";
//redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useNavigate, useParams } from "react-router-dom";
import Url from "../../../apiCall/UrlConfig";
import ImageSizeComponent from "../../../component/imageSize";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;

// همان ۳۴ نقطه‌ای که مدل pose برمی‌گرداند و آنالیز بدون آن‌ها کامل نیست.
const REQUIRED_POINTS = [
  "Tr", "FtR", "FzR", "ZyR", "GoR", "Me",
  "GoL", "ZyL", "FzL", "FtL", "G", "N",
  "AlR", "SbalR", "Sn", "SbalL", "AlL",
  "Prn", "ExternCR", "PupilR", "InterCR",
  "FmR", "FmL", "InterCL", "PupilL",
  "ExternCL", "ChR", "ChL", "CphR",
  "CphL", "ls", "Sto", "Li", "Sl",
];

// موقعیت پیش‌فرض نقاط، نسبت به تصویری با ابعاد BASE_WIDTH×BASE_HEIGHT؛ برای
// شروع دستی و برای جای دادن نقاطی که AI پیدا نکرده استفاده می‌شود.
const BASE_WIDTH = 662;
const BASE_HEIGHT = 997;
const DEFAULT_POINTS = {
    Tr: {
      x: 330,
      y: 188,
    },
    G: {
      x: 329,
      y: 386,
    },
    N: {
      x: 330,
      y: 408,
    },
    Prn: {
      x: 337,
      y: 589,
    },
    Sn: {
      x: 335,
      y: 631,
    },
    ls: {
      x: 332,
      y: 691,
    },
    Sto: {
      x: 331,
      y: 715,
    },
    Li: {
      x: 334,
      y: 753,
    },
    Sl: {
      x: 335,
      y: 781,
    },
    Me: {
      x: 336,
      y: 887,
    },
    FtL: {
      x: 483,
      y: 343,
    },
    FzL: {
      x: 544,
      y: 394,
    },
    ZyL: {
      x: 574,
      y: 527,
    },
    GoL: {
      x: 502,
      y: 808,
    },
    FtR: {
      x: 159,
      y: 351,
    },
    FzR: {
      x: 109,
      y: 413,
    },
    ZyR: {
      x: 82,
      y: 535,
    },
    GoR: {
      x: 139,
      y: 786,
    },
    FmR: {
      x: 286,
      y: 432,
    },
    AlR: {
      x: 257,
      y: 598,
    },
    SbalR: {
      x: 273,
      y: 619,
    },
    ChR: {
      x: 228,
      y: 714,
    },
    CphR: {
      x: 301,
      y: 688,
    },
    FmL: {
      x: 369,
      y: 431,
    },
    AlL: {
      x: 403,
      y: 602,
    },
    SbalL: {
      x: 385,
      y: 617,
    },
    ChL: {
      x: 427,
      y: 713,
    },
    CphL: {
      x: 356,
      y: 688,
    },
    InterCL: {
      x: 386,
      y: 464,
    },
    ExternCL: {
      x: 499,
      y: 445,
    },
    PupilL: {
      x: 441,
      y: 437,
    },
    InterCR: {
      x: 274,
      y: 464,
    },
    ExternCR: {
      x: 154,
      y: 453,
    },
    PupilR: {
      x: 211,
      y: 439,
    },
  };

const AnalysisFrontal = (props) => {
  let navigate = useNavigate();
  const { patinetId, analyseId, imageUrl, imageType } = useParams();
  const [pointPositions, setPointPositions] = useState({});

  const [LateralCephaloAnaLysis, setCephaloAnalysis] = useState([]);

  const [api, contextHolder] = notification.useNotification();

  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });
  const [missingPoints, setMissingPoints] = useState([]);

  useEffect(() => {
    _calculate();
  }, [pointPositions]);
  const _calculate = () => {
    console.log(pointPositions);
    return;
    const pointS = pointPositions["S"];
    const pointGo = pointPositions["Go"];
    const pointMe = pointPositions["Me"];
    const pointN = pointPositions["N"];
    const pointGn = pointPositions["Gn"];
    const pointA = pointPositions["A"];
    const pointB = pointPositions["B"];
    const pointAr = pointPositions["Ar"];
    const pointOr = pointPositions["Or"];
    const pointPo = pointPositions["Po"];
    //calculate jarobak index
    const distanceSGo = calculateDistance(pointS, pointGo);
    const distanceNMe = calculateDistance(pointN, pointMe);
    if (distanceSGo == 0 || distanceNMe == 0) {
      message.error("Please select all the points");
      return;
    }
    const jarobakIndex = (distanceSGo / distanceNMe) * 100;

    //calculate angle
    const YAxis = calculateAngle(pointN, pointS, pointGn);
    const ANBDegree = calculateSignedAngle(pointA, pointN, pointB);
    const ArticularAngle = calculateAngle(pointS, pointAr, pointGo);
    const SNAangle = calculateAngle(pointS, pointN, pointA);
    const SNBangle = calculateAngle(pointS, pointN, pointB);
    const SNFHAngle = calculateAngleBetweenLines(
      pointS,
      pointN,
      pointPo,
      pointOr
    );
    const SN_GoMeAngle = calculateAngleBetweenLines(
      pointS,
      pointN,
      pointGo,
      pointMe
    );
    const SN_GoGn = calculateAngleBetweenLines(
      pointS,
      pointN,
      pointGo,
      pointGn
    );

    const FHMeGo = calculateAngleBetweenLines(
      pointPo,
      pointOr,
      pointGo,
      pointMe
    );

    console.log("Jarobak Index:", jarobakIndex);
    console.log("YAxis:", YAxis);
    console.log("ANB", ANBDegree);
    console.log("Articular Angle", ArticularAngle);
    console.log("SNA", SNAangle);
    console.log("SNB", SNBangle);
    console.log("SNFHAngle", SNFHAngle);
    setCephaloAnalysis([
      {
        key: "jarobak Index",
        label: "jarobak Index",
        value: jarobakIndex.toFixed(2) + "  %  ",
      },
      {
        key: "YAxis",
        label: "YAxis",
        value: YAxis.toFixed(2),
      },
      {
        key: "ANB Degree",
        label: "ANB Degree",
        value: ANBDegree.toFixed(2),
      },
      {
        key: "ArticularAngle",
        label: "Articular Angle",
        value: ArticularAngle.toFixed(2),
      },
      {
        key: "SNA   angle",
        label: "SNAangle",
        value: SNAangle.toFixed(2),
      },
      {
        key: "SNB  angle",
        label: "SNB  angle",
        value: SNBangle.toFixed(2),
      },
      {
        key: "SN-FH  angle",
        label: "SN-FH   angle",
        value: SNFHAngle.toFixed(2),
      },
      {
        key: "SN-GoMe  angle",
        label: "SN-GoMe   angle",
        value: SN_GoMeAngle.toFixed(2),
      },
      {
        key: "FH - GoMe  angle",
        label: "FH - GoMe   angle",
        value: FHMeGo.toFixed(2),
      },
      {
        key: "SN_GoGn  angle",
        label: "SN_GoGn   angle",
        value: SN_GoGn.toFixed(2),
      },
    ]);
  };

  useEffect(() => {
    if (parseInt(analyseId) > 0) {
      _getForEdit();
    }
  }, []);

  useEffect(() => {
    if (parseInt(analyseId) == 0 && imageSize?.width > 0) {
      _modifyForFirst();
    }
  }, [imageSize]);

  const _getForEdit = async () => {
    let url = Url.profile_FrontalGetAnalysesForEdit;
    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      AnalyseId: parseInt(analyseId),
      PatientId: parseInt(patinetId),
    });

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
    let listPos = {};
    for (
      let index = 0;
      index < res?.data?.frontalProfilePositions.length;
      index++
    ) {
      const element = res?.data?.frontalProfilePositions[index];
      listPos[element.type] = { x: element.xposition, y: element.yposition };
    }
    setPointPositions(listPos);
  };

  const _scaleDefaultPoint = (key) => {
    const base = DEFAULT_POINTS[key];
    if (base == null) {
      // نقطه‌ای که موقعیت پیش‌فرض ندارد وسط تصویر گذاشته می‌شود.
      return {
        x: parseInt(imageSize.width / 2),
        y: parseInt(imageSize.height / 2),
      };
    }
    return {
      x: parseInt(base.x * (imageSize.width / BASE_WIDTH)),
      y: parseInt(base.y * (imageSize.height / BASE_HEIGHT)),
    };
  };

  const _modifyForFirst = () => {
    let _point = {};
    for (const key of REQUIRED_POINTS) {
      _point[key] = _scaleDefaultPoint(key);
    }

    setPointPositions(_point);
    setMissingPoints([]);
  };

  // نقطه‌ای که AI پیدا نکرده را روی موقعیت پیش‌فرضش می‌گذارد تا کاربر بتواند
  // آن را بکشد و سر جای درست ببرد.
  const _addMissingPoint = (key) => {
    setPointPositions((prevPositions) => ({
      ...prevPositions,
      [key]: _scaleDefaultPoint(key),
    }));
    setMissingPoints((prev) => prev.filter((item) => item != key));
  };

  const _addAllMissingPoints = () => {
    setPointPositions((prevPositions) => {
      let _new = { ...prevPositions };
      for (const key of REQUIRED_POINTS) {
        if (_new[key] == null) _new[key] = _scaleDefaultPoint(key);
      }
      return _new;
    });
    setMissingPoints([]);
  };

  const calculateDistance = (point1, point2) => {
    const dx = point2.x - point1.x;
    const dy = point2.y - point1.y;
    return Math.sqrt(dx * dx + dy * dy);
  };

  const calculateAngle = (pointA, pointB, pointC) => {
    let dAB = calculateDistance(pointA, pointB);
    let dAC = calculateDistance(pointA, pointC);
    let dBC = calculateDistance(pointB, pointC);
    let acosTeta = (dAB ** 2 + dBC ** 2 - dAC ** 2) / (2 * dAB * dBC);
    let tettaRad = Math.acos(acosTeta);
    let tetaDegree = tettaRad * (180 / Math.PI);
    return tetaDegree;
  };
  const calculateSignedAngle = (pointA, pointB, pointC) => {
    const vectorAB = { x: pointB.x - pointA.x, y: pointB.y - pointA.y };
    const vectorBC = { x: pointC.x - pointB.x, y: pointC.y - pointB.y };

    const dotProduct = vectorAB.x * vectorBC.x + vectorAB.y * vectorBC.y;
    const crossProduct = vectorAB.x * vectorBC.y - vectorAB.y * vectorBC.x;

    const magnitudeAB = Math.sqrt(vectorAB.x ** 2 + vectorAB.y ** 2);
    const magnitudeBC = Math.sqrt(vectorBC.x ** 2 + vectorBC.y ** 2);

    let acosTeta = dotProduct / (magnitudeAB * magnitudeBC);

    // Ensure acosTeta is within the valid range [-1, 1]
    acosTeta = Math.max(-1, Math.min(1, acosTeta));

    let tettaRad = Math.acos(acosTeta);

    // Determine the sign of the angle based on the cross product
    if (crossProduct < 0) {
      tettaRad = -tettaRad;
    }

    // Convert angle to degrees
    let tetaDegree = tettaRad * (180 / Math.PI);

    if (tetaDegree < 0) {
      tetaDegree = 180 + tetaDegree;
    } else {
      tetaDegree = tetaDegree - 180;
    }

    return tetaDegree;
  };
  const _onstop = (event, data, label) => {
    let x = parseInt(data.x.toFixed());
    let y = parseInt(data.y.toFixed());
    // console.log(x, y, label);
    // console.log(data);

    setPointPositions((prevPositions) => ({
      ...prevPositions,
      [label]: { x: x, y: y },
    }));
  };

  const calculateAngleBetweenLines = (pointA, pointB, pointC, pointD) => {
    // Calculate the vectors AB and CD
    let vectorAB = { x: pointB.x - pointA.x, y: pointB.y - pointA.y };
    let vectorCD = { x: pointD.x - pointC.x, y: pointD.y - pointC.y };

    // Calculate the dot product of AB and CD
    let dotProduct = vectorAB.x * vectorCD.x + vectorAB.y * vectorCD.y;

    // Calculate the magnitudes of AB and CD
    let magnitudeAB = Math.sqrt(vectorAB.x ** 2 + vectorAB.y ** 2);
    let magnitudeCD = Math.sqrt(vectorCD.x ** 2 + vectorCD.y ** 2);

    // Calculate the angle between the vectors using the dot product formula
    let cosTheta = dotProduct / (magnitudeAB * magnitudeCD);
    let thetaRad = Math.acos(cosTheta);
    let thetaDegree = thetaRad * (180 / Math.PI);
    return thetaDegree;
  };

  const _returnDraggbleView = () => {
    let _output = [];
    for (let key in pointPositions) {
      _output.push(
        <Draggable
          onStop={(event, data) => _onstop(event, data, key)}
          // bounds="parent"
          defaultPosition={pointPositions[key]}
          position={pointPositions[key]}
        >
          <div className="DragableContainer">
            <div className="circlePoint" />
            {/* <div className="linewithAngle" /> */}
            <div className="labelPoint">{key}</div>
          </div>
        </Draggable>
      );
    }
    return _output;
  };

  const _getPointsWithAi = async () => {
    let url = Url.profile_FrontalGetPointWithAi;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {
      PatientId: parseInt(patinetId),
    });

    if (res.hasError) {
      message.error(res.message);
      return;
    }

    let aiResult = res?.data;

    if (!aiResult?.detected) {
      setMissingPoints(REQUIRED_POINTS);
      api.error({
        message: "چهره‌ای تشخیص داده نشد",
        description: "همه‌ی ۳۴ نقطه را باید دستی روی تصویر مشخص کنید.",
        duration: 0,
      });
      return;
    }

    // مختصات مدل در فضای پیکسل خود تصویر است و تصویر هم با اندازه‌ی طبیعی
    // رندر می‌شود، پس نیازی به تبدیل مقیاس نیست.
    let listPos = {};
    for (const point of aiResult.points || []) {
      listPos[point.type] = { x: point.x, y: point.y };
    }
    setPointPositions(listPos);

    let missing = REQUIRED_POINTS.filter((key) => listPos[key] == null);
    setMissingPoints(missing);

    if (missing.length > 0) {
      api.warning({
        message: `${missing.length} نقطه پیدا نشد`,
        description:
          "این نقاط را باید دستی روی تصویر مشخص کنید: " + missing.join("، "),
        duration: 0,
      });
      return;
    }

    message.success(
      "همه‌ی نقاط تشخیص داده شد (confidence: " + aiResult.confidence + ")"
    );
  };

  const _SaveAnalyses = async () => {
    let url = Url.profile_FrontalSaveAnalyses;

    // آنالیز ناقص ذخیره نمی‌شود؛ اگر AI نقطه‌ای را پیدا نکرده باشد کاربر باید
    // خودش آن را روی تصویر بگذارد.
    let missing = REQUIRED_POINTS.filter((key) => pointPositions[key] == null);
    if (missing.length > 0) {
      api.error({
        message: `${missing.length} نقطه انتخاب نشده است`,
        description:
          "برای ذخیره باید همه‌ی ۳۴ نقطه روی تصویر مشخص شوند. نقاط جامانده: " +
          missing.join("، "),
        duration: 0,
      });
      return;
    }

    let lateralCephaloPositions = [];
    for (let key in pointPositions) {
      lateralCephaloPositions.push({
        type: key,
        xposition: pointPositions[key].x,
        yposition: pointPositions[key].y,
      });
    }

    let id = parseInt(analyseId);

    let data = {
      id: id ? id : 0,
      patientId: patinetId,
      patientImageId: 0,
      FrontalProfilePositions: lateralCephaloPositions,
    };

    let res = await props.actions.CallCoreServicesActionWithToken(url, data);

    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }

    message.success(res.message);
    navigate("/ProfileAnalysis");
  };

  const _returnLIstPoints = () => {
    let _output = [];
    const _onDeletePoint = (key) => {
      let _new = {};

      for (const _key in pointPositions) {
        if (_key != key) {
          _new[_key] = pointPositions[_key];
        }
      }
      setPointPositions(_new);
    };
    for (let key in pointPositions) {
      _output.push(
        <div>
          {key} :{" "}
          <Button
            style={{ marginLeft: 20 }}
            onClick={() => _onDeletePoint(key)}
          >
            Del
          </Button>
        </div>
      );
    }
    return _output;
  };

  return (
    <div dir="ltr">
      {props.coreData[Url.profile_FrontalGetAnalysesForEdit]?.[Url.action]
        ?.isFetching && <Spin />}
      {contextHolder}

      <ImageSizeComponent
        imageUrl={ImagePreAddress + imageType + "/" + imageUrl}
        onImageLoad={(width, height) => setImageSize({ width, height })}
      />
      {imageSize.width > 0 && imageSize.height > 0 && (
        <>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              style={{
                backgroundColor: "red",
                position: "relative",
                width: imageSize.width,
                height: imageSize.height,
              }}
            >
              <img
                src={ImagePreAddress + imageType + "/" + imageUrl}
                className="imageCephalo"
                draggable={false}
              />
              {_returnDraggbleView()}
            </div>
            {/* <div>{_returnLIstPoints()}</div> */}

            {missingPoints.length > 0 && (
              <div style={{ marginLeft: 20, minWidth: 220 }}>
                <div style={{ color: "red", marginBottom: 8 }}>
                  {missingPoints.length} نقطه پیدا نشد
                </div>
                <Button
                  size="small"
                  onClick={() => _addAllMissingPoints()}
                  style={{ marginBottom: 8 }}
                >
                  افزودن همه‌ی نقاط جامانده
                </Button>
                {missingPoints.map((key) => (
                  <div key={key} style={{ marginBottom: 4 }}>
                    <Button size="small" onClick={() => _addMissingPoint(key)}>
                      + {key}
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <Button
              loading={
                props.coreData[Url.profile_FrontalGetPointWithAi]?.[Url.action]
                  ?.isFetching
              }
              onClick={() => _getPointsWithAi()}
            >
              تشخیص نقاط با AI
            </Button>

            <Button onClick={() => _modifyForFirst()}>
              نقاط پیش‌فرض
            </Button>

            <Button
              loading={
                props.coreData[Url.profile_FrontalSaveAnalyses]?.[Url.action]
                  ?.isFetching ||
                props.coreData[Url.profile_FrontalGetAnalysesForEdit]?.[
                  Url.action
                ]?.isFetching
              }
              type="primary"
              onClick={() => _SaveAnalyses()}
            >
              {parseInt(analyseId) == 0 ? "Save " : "Update "} Analyses
            </Button>

            <span>
              {Object.keys(pointPositions).length} / {REQUIRED_POINTS.length}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalysisFrontal);
